import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { LanguageModule } from '@language';
import { sessionStorageHelper, ShNotificationComponent } from '@stylehaven/components';
import { ErrorPageTemplate } from '../error-page/error-page.template';
import { ErrorPageContainerComponent } from '../error-page/error-page.container.component';

@Component({
    standalone: true,
    imports: [ShNotificationComponent, LanguageModule],
    selector: 'med-page-not-found-container',
    template: ErrorPageTemplate,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageNotFoundContainerComponent extends ErrorPageContainerComponent implements OnInit {
    protected title: string = 'components.not-found.title';
    protected message: string = 'components.not-found.message';

    ngOnInit() {
        if (sessionStorageHelper.has('shareToken')) {
            this.message = 'components.not-found-share.message';
            this.title = 'components.not-found-share.title';
        }
    }
}
